const materialRating = {
  yes: 5,
  partial: 3,
  somewhat: 3,
  no: 1,
}

export default materialRating
